import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import TestScreen from '../screen'

const SurveysRoutes = () => {
    return (
        <React.Fragment>
            <Route exact path='/test' component={TestScreen} />
        </React.Fragment>
    )
}

export default SurveysRoutes